/**
 * Product gallery thumbnail switcher for gap-product-main section.
 * Clears responsive srcset when switching so the browser actually updates the hero image.
 */
function initGapProductGallery(gallery) {
  if (!gallery || gallery.dataset.gapGalleryInit === 'true') return;

  const hero = gallery.querySelector('.gap-product-main__hero');
  const mainImage = gallery.querySelector('[data-gap-main-image]');
  const thumbs = gallery.querySelectorAll('[data-gap-thumb]');

  if (!mainImage || !thumbs.length) return;

  gallery.dataset.gapGalleryInit = 'true';

  gallery.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gap-thumb]');
    if (!thumb || !gallery.contains(thumb)) return;

    const src = thumb.dataset.src;
    if (!src || thumb.classList.contains('is-active')) return;

    const srcset = thumb.dataset.srcset || '';

    hero?.classList.add('is-switching');

    const applyImage = () => {
      mainImage.src = src;

      if (srcset) {
        mainImage.srcset = srcset;
      } else {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
      }

      thumbs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-selected', 'true');

      window.setTimeout(() => hero?.classList.remove('is-switching'), 350);
    };

    const preload = new Image();
    preload.onload = applyImage;
    preload.onerror = applyImage;
    preload.src = src;
  });
}

function initAllGapProductGalleries() {
  document.querySelectorAll('[data-gap-product-gallery]').forEach(initGapProductGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllGapProductGalleries);
} else {
  initAllGapProductGalleries();
}

document.addEventListener('shopify:section:load', (event) => {
  const gallery = event.target.querySelector?.('[data-gap-product-gallery]');
  if (gallery) initGapProductGallery(gallery);
});
